module.exports = __webpack_public_path__ + "img/2003.c240a96d.png";